import { gql } from '@apollo/client'

export const OBJECT_SECURITY_CREATE_MUTATION = gql`
  mutation OBJECT_SECURITY_CREATE_MUTATION($companyId: ID, $input: ObjectSecurityInput!) {
    objectSecurityCreate(companyId: $companyId, input: $input) {
      data {
        id
      }
    }
  }
`

export const OBJECT_SECURITY_UPDATE_MUTATION = gql`
  mutation OBJECT_SECURITY_UPDATE_MUTATION($id: ID!, $companyId: ID, $input: ObjectSecurityInput!) {
    objectSecurityUpdate(id: $id, companyId: $companyId, input: $input) {
      data {
        id
      }
    }
  }
`

export const OBJECT_SECURITY_DELETE_MUTATION = gql`
  mutation OBJECT_SECURITY_DELETE_MUTATION($id: ID!, $companyId: ID) {
    objectSecurityDelete(id: $id, companyId: $companyId) {
      ok
    }
  }
`
